import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { BookkeepingItem } from '../types/bookkeepingItem'
import { getItemAmountInAccountCurrency } from './getItemAmountInAccountCurrency'
import { roundAmount } from './roundAmount'

export const calculateDifference = (
  transaction: BankLine,
  selectedItems: BookkeepingItem[],
  accountCurrency?: string,
): number => {
  const bankLineAmount = transaction.side === 'debit' ? transaction.amount : -transaction.amount

  const itemsTotal = selectedItems.reduce((total, item) => {
    const itemAmount = getItemAmountInAccountCurrency(item, accountCurrency)
    const signedAmount = item.side === 'debit' ? itemAmount : -itemAmount
    return total + signedAmount
  }, 0)

  return roundAmount(bankLineAmount - itemsTotal)
}
